<script setup>
// auth store
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

</script>

<template>
	<SectionCard title="App Documentation">
		<Heading size="2">Adding a Payment Method</Heading>
		<Alert type="info" class="text-sm" v-if="!auth.can('manage_payment_methods')"><b>Note:</b> Only users with the "Manage Payment Methods" permissions are able to add and remove payment methods on behalf of their organisation. <b>You do not have this permission on your account.</b> You'll need to ask your organisation head for the proper access.</Alert>

		<br />

		<div v-if="auth.isAdmin">
			<p>As an admin, you can add a payment method to any organisation. To do this, navigate to the organisation you want to add a payment method to and scroll down to see the "Payment Methods" section. You'll see a list of payment methods that have been added to the organisation (it may be empty). Click the "Add Payment Method" button to add a new payment method.</p>
		</div>

		<div v-else>
			<p>In order to add a payment method, click on the "Payment Methods" link in the site navigation on the left side of the page. You'll see a list of payment methods that have been added to your organisation (it may be empty). Click the "Add Payment Method" button to add a new payment method.</p>
		</div>

		<img src="/images/docs/payment-methods-list.png" class="w-full p-8" />

		<p>You can set any single payment method as the one to use for automatic payments. This card will be automatically charged when the next membership invoice comes due. See <Link :href="route('dashboard.docs.managing-invoices')">Viewing Invoices</Link> for more information on invoices.</p>
		<br />
		<p>In order to set a payment method to be used for automatic payments, click the card in your list to highlight it and then click "Toggle Automatic Payment Method". You will see a green alert in the list denoting the card that is in use for automatic payments.</p>
		<img src="/images/docs/payment-method-selected.png" class="w-full p-8" />
		<img src="/images/docs/payment-method-auto.png" class="w-full p-8" />

	</SectionCard>
</template>